import {InvoiceLink, RentalItem, SiteSummary, Todo} from "./dtos";

export interface InvoiceEntry {
  id?: number;
  sourceEntityId?: number;
  name: string;
  amount: number | null;
  amountType: string;
  price: number | null;
  total: number | null;
  vat?: string;
  grossPrice?: number;
  comment: string | null;
  override?: InvoiceEntryOverride;
}

export interface InvoiceEntryOverride {
  price: number;
  amountType: string;
  amount: number;
  total: number | null;
}

export interface RentalItemOverride {
  price: number;
  amountType: string;
  amount: number;
  total: number | null;
}

export interface ClientRentalSummary {
  rental: {
    id: number;
    date: string;
  },
  returnal?: null | {
    id: number;
    date: string;
  },
  rentalItem: RentalItem;
  amount: number | null,
  total: number | null,
  finalized: boolean;
  todo: Todo | null;
  override: RentalItemOverride | null;
  invoice?: InvoiceLink;
}

export function getTotalFromOverrideOrItem(item: InvoiceEntry): number | null {
  return item.override ? item.override.total : item.total;
}

export function getTotalFromOverridesOrSummaries(items: InvoiceEntry[]): number {
  let total = 0.0;
  items.forEach(s => {
    const summaryTotal = getTotalFromOverrideOrItem(s);
    total += summaryTotal || 0.0;
  });
  return total;
}

export function getAmountTypeFromOverrideOrItem(item: InvoiceEntry): string {
  return item.override ? item.override.amountType : item.amountType;
}

export function getAmountFromOverrideOrItem(item: InvoiceEntry): number | null {
  return item.override ? item.override.amount : item.amount;
}

export function getPriceFromOverrideOrItem(item: InvoiceEntry): number | null {
  return item.override ? item.override.price : item.price;
}

export interface ClientRentalSummaryGridSection {
  siteSummary: SiteSummary;
  summaries: ClientRentalSummary[];
}

export interface ClientRentalSummaryGridResponse {
  count: number;
  total: number;
  sections: ClientRentalSummaryGridSection[];
}

export interface ClientRentalSummaryGridRequest {
  clientId: number;
  year: number;
  month: number;
}

export interface SaveOverrideRequest {
  rentalItemId: number;
  year: number;
  month: number;
  override: RentalItemOverride;
}

export interface DeleteOverrideRequest {
  rentalItemId: number;
  year: number;
  month: number;
}


// WEBPACK FOOTER //
// ./src/api/dtos/summaries.ts